import React, { useEffect } from 'react'

function use3DViewerEvent(targetEvent, cb) {
  useEffect(() => {
    const listener = (event) => {
      if (event.data.type === `3d-viewer:${targetEvent}`) {
        cb(event.data)
      }
    }
    // Listen for messages from the iframe
    window.addEventListener('message', listener, false)

    return () => {
      window.removeEventListener('message', listener)
    }
  }, [targetEvent, cb])
}

export default use3DViewerEvent
